'use strict';

angular.module('ClinicApp').controller('ModalGenericSaveClose', function($scope, $modalInstance) {
  $scope.save = function() {
    $modalInstance.close();
  };

  $scope.close = function() {
    $modalInstance.dismiss();
  };
});
